import DigitalMarketingOptions from "@store/modules/DigitalMarketingOptions";
const COUNTRIES = [
  "Afghanistan",
  "Albania",
  "Algeria",
  "American Samoa",
  "Andorra",
  "Angola",
  "Anguilla",
  "Antarctica",
  "Antigua and Barbuda",
  "Argentina",
  "Armenia",
  "Aruba",
  "Australia",
  "Austria",
  "Azerbaijan",
  "Bahamas",
  "Bahrain",
  "Bangladesh",
  "Barbados",
  "Belarus",
  "Belgium",
  "Belize",
  "Benin",
  "Bermuda",
  "Bhutan",
  "Bolivia",
  "Bosnia and Herzegowina",
  "Botswana",
  "Bouvet Island",
  "Brazil",
  "British Indian Ocean Territory",
  "Brunei Darussalam",
  "Bulgaria",
  "Burkina Faso",
  "Burundi",
  "Cambodia",
  "Cameroon",
  "Canada",
  "Cape Verde",
  "Cayman Islands",
  "Central African Republic",
  "Chad",
  "Chile",
  "China",
  "Christmas Island",
  "Cocos (Keeling) Islands",
  "Colombia",
  "Comoros",
  "Congo",
  "Congo, the Democratic Republic of the",
  "Cook Islands",
  "Costa Rica",
  "Cote d'Ivoire",
  "Croatia (Hrvatska)",
  "Cuba",
  "Cyprus",
  "Czech Republic",
  "Denmark",
  "Djibouti",
  "Dominica",
  "Dominican Republic",
  "East Timor",
  "Ecuador",
  "Egypt",
  "El Salvador",
  "Equatorial Guinea",
  "Eritrea",
  "Estonia",
  "Ethiopia",
  "Falkland Islands (Malvinas)",
  "Faroe Islands",
  "Fiji",
  "Finland",
  "France",
  "France Metropolitan",
  "French Guiana",
  "French Polynesia",
  "French Southern Territories",
  "Gabon",
  "Gambia",
  "Georgia",
  "Germany",
  "Ghana",
  "Gibraltar",
  "Greece",
  "Greenland",
  "Grenada",
  "Guadeloupe",
  "Guam",
  "Guatemala",
  "Guinea",
  "Guinea-Bissau",
  "Guyana",
  "Haiti",
  "Heard and Mc Donald Islands",
  "Holy See (Vatican City State)",
  "Honduras",
  "Hong Kong",
  "Hungary",
  "Iceland",
  "India",
  "Indonesia",
  "Iran (Islamic Republic of)",
  "Iraq",
  "Ireland",
  "Israel",
  "Italy",
  "Jamaica",
  "Japan",
  "Jordan",
  "Kazakhstan",
  "Kenya",
  "Kiribati",
  "Korea, Democratic People's Republic of",
  "Korea, Republic of",
  "Kuwait",
  "Kyrgyzstan",
  "Lao, People's Democratic Republic",
  "Latvia",
  "Lebanon",
  "Lesotho",
  "Liberia",
  "Libyan Arab Jamahiriya",
  "Liechtenstein",
  "Lithuania",
  "Luxembourg",
  "Macau",
  "Macedonia, The Former Yugoslav Republic of",
  "Madagascar",
  "Malawi",
  "Malaysia",
  "Maldives",
  "Mali",
  "Malta",
  "Marshall Islands",
  "Martinique",
  "Mauritania",
  "Mauritius",
  "Mayotte",
  "Mexico",
  "Micronesia, Federated States of",
  "Moldova, Republic of",
  "Monaco",
  "Mongolia",
  "Montserrat",
  "Morocco",
  "Mozambique",
  "Myanmar",
  "Namibia",
  "Nauru",
  "Nepal",
  "Netherlands",
  "Netherlands Antilles",
  "New Caledonia",
  "New Zealand",
  "Nicaragua",
  "Niger",
  "Nigeria",
  "Niue",
  "Norfolk Island",
  "Northern Mariana Islands",
  "Norway",
  "Oman",
  "Pakistan",
  "Palau",
  "Panama",
  "Papua New Guinea",
  "Paraguay",
  "Peru",
  "Philippines",
  "Pitcairn",
  "Poland",
  "Portugal",
  "Puerto Rico",
  "Qatar",
  "Reunion",
  "Romania",
  "Russian Federation",
  "Rwanda",
  "Saint Kitts and Nevis",
  "Saint Lucia",
  "Saint Vincent and the Grenadines",
  "Samoa",
  "San Marino",
  "Sao Tome and Principe",
  "Saudi Arabia",
  "Senegal",
  "Seychelles",
  "Sierra Leone",
  "Singapore",
  "Slovakia (Slovak Republic)",
  "Slovenia",
  "Solomon Islands",
  "Somalia",
  "South Africa",
  "South Georgia and the South Sandwich Islands",
  "Spain",
  "Sri Lanka",
  "St. Helena",
  "St. Pierre and Miquelon",
  "Sudan",
  "Suriname",
  "Svalbard and Jan Mayen Islands",
  "Swaziland",
  "Sweden",
  "Switzerland",
  "Syrian Arab Republic",
  "Taiwan, Province of China",
  "Tajikistan",
  "Tanzania, United Republic of",
  "Thailand",
  "Togo",
  "Tokelau",
  "Tonga",
  "Trinidad and Tobago",
  "Tunisia",
  "Turkey",
  "Turkmenistan",
  "Turks and Caicos Islands",
  "Tuvalu",
  "Uganda",
  "Ukraine",
  "United Arab Emirates",
  "United Kingdom",
  "United States",
  "United States Minor Outlying Islands",
  "Uruguay",
  "Uzbekistan",
  "Vanuatu",
  "Venezuela",
  "Vietnam",
  "Virgin Islands (British)",
  "Virgin Islands (U.S.)",
  "Wallis and Futuna Islands",
  "Western Sahara",
  "Yemen",
  "Yugoslavia",
  "Zambia",
  "Zimbabwe",
];
const STATES = {
  AL: "Alabama",
  AK: "Alaska",
  AZ: "Arizona",
  AR: "Arkansas",
  CA: "California",
  CO: "Colorado",
  CT: "Connecticut",
  DE: "Delaware",
  FL: "Florida",
  GA: "Georgia",
  HI: "Hawaii",
  ID: "Idaho",
  IL: "Illinois",
  IN: "Indiana",
  IA: "Iowa",
  KS: "Kansas",
  KY: "Kentucky",
  LA: "Louisiana",
  ME: "Maine",
  MD: "Maryland",
  MA: "Massachusetts",
  MI: "Michigan",
  MN: "Minnesota",
  MS: "Mississippi",
  MO: "Missouri",
  MT: "Montana",
  NE: "Nebraska",
  NV: "Nevada",
  NH: "New Hampshire",
  NJ: "New Jersey",
  NM: "New Mexico",
  NY: "New York",
  NC: "North Carolina",
  ND: "North Dakota",
  OH: "Ohio",
  OK: "Oklahoma",
  OR: "Oregon",
  PA: "Pennsylvania",
  RI: "Rhode Island",
  SC: "South Carolina",
  SD: "South Dakota",
  TN: "Tennessee",
  TX: "Texas",
  UT: "Utah",
  VT: "Vermont",
  VA: "Virginia",
  WA: "Washington",
  WV: "West Virginia",
  WI: "Wisconsin",
  WY: "Wyoming",
};
const FONT_FAMILY = {
  "Arial,Helvetica,sans-serif": "Arial",
  "sans-serif": "Sans Serif",
  "Georgia,serif": "Georgia",
  "Impact,Charcoal,sans-serif": "Impact",
  "Tahoma,Geneva,sans-serif": "Tahoma",
  "'Times New Roman',Times,serif": "Times New Roman",
  "Verdana,Geneva,sans-serif": "Verdana",
  "'Poppins',sans-serif": "Poppins",
  "'Roboto',sans-serif": "Roboto",
  "'Open Sans',sans-serif": "Open Sans",
  "'Montserrat',sans-serif": "Montserrat",
  "'Lato',sans-serif": "Lato",
  "'Oswald',sans-serif": "Oswald",
  "'Raleway',sans-serif": "Raleway",
  "'Ubuntu',sans-serif": "Ubuntu",
  "'Nunito',sans-serif": "Nunito",
  "'Merriweather',sans-serif": "Merriweather",
  "'Rubik',sans-serif": "Rubik",
  "'Caramel',sans-serif": "Caramel",
  "'Dancing Script',sans-serif": "Dancing Script",
  "'Bebas Neue',sans-serif": "Bebas Neue",
  "'Lobster',sans-serif": "Lobster",
};
const FONT_FAMILY1 = [
  { val: "Arial,Helvetica,sans-serif", label: "Arial" },
  { val: "sans-serif", label: "Sans Serif" },
  { val: "Georgia,serif", label: "Georgia" },
  { val: "Impact,Charcoal,sans-serif", label: "Impact" },
  { val: "Tahoma,Geneva,sans-serif", label: "Tahoma" },
  { val: "'Times New Roman',Times,serif", label: "Times New Roman" },
  { val: "Verdana,Geneva,sans-serif", label: "Verdana" },
  { val: "'Poppins',sans-serif", label: "Poppins" },
  { val: "'Roboto',sans-serif", label: "Roboto" },
  { val: "'Open Sans',sans-serif", label: "Open Sans" },
  { val: "'Montserrat',sans-serif", label: "Montserrat" },
  { val: "'Lato',sans-serif", label: "Lato" },
  { val: "'Oswald',sans-serif", label: "Oswald" },
  { val: "'Raleway',sans-serif", label: "Raleway" },
  { val: "'Ubuntu',sans-serif", label: "Ubuntu" },
  { val: "'Nunito',sans-serif", label: "Nunito" },
  { val: "'Merriweather',sans-serif", label: "Merriweather" },
  { val: "'Rubik',sans-serif", label: "Rubik" },
  { val: "'Caramel',sans-serif", label: "Caramel" },
  { val: "'Dancing Script',sans-serif", label: "Dancing Script" },
  { val: "'Bebas Neue',sans-serif", label: "Bebas Neue" },
  { val: "'Lobster',sans-serif", label: "Lobster" },
];

const FONT_WEIGHT = {
  "Arial,Helvetica,sans-serif": ["400", "700"],
  "Georgia,serif": ["400", "700"],
  "Impact,Charcoal,sans-serif": ["400"],
  "Tahoma,Geneva,sans-serif": ["400", "700"],
  "'Times New Roman',Times,serif": ["400", "700"],
  "Verdana,Geneva,sans-serif": ["400", "700"],
  "sans-serif": ["300", "400", "700"],
  "'Poppins',sans-serif": [
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900",
  ],
  "'Roboto',sans-serif": ["100", "300", "400", "500", "700", "900"],
  "'Open Sans',sans-serif": ["300", "400", "500", "600", "700", "800"],
  "'Montserrat',sans-serif": [
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900",
  ],
  "'Lato',sans-serif": ["100", "300", "400", "700", "900"],
  "'Oswald',sans-serif": ["200", "300", "400", "500", "600", "700"],
  "'Raleway',sans-serif": [
    "100",
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900",
  ],
  "'Ubuntu',sans-serif": ["300", "400", "500", "700"],
  "'Nunito',sans-serif": [
    "200",
    "300",
    "400",
    "500",
    "600",
    "700",
    "800",
    "900",
  ],
  "'Merriweather',sans-serif": ["300", "400", "700", "900"],
  "'Rubik',sans-serif": ["300", "400", "500", "600", "700", "800", "900"],
  "'Caramel',sans-serif": ["400"],
  "'Dancing Script',sans-serif": ["400", "500", "600", "700"],
  "'Bebas Neue',sans-serif": ["400"],
  "'Lobster',sans-serif": ["400"],
};
const FONT_WEIGHT_LABELS = {
  100: "Thin",
  200: "Extra Light",
  300: "Light",
  400: "Regular",
  500: "Medium",
  600: "Semi Bold",
  700: "Bold",
  800: "Extra Bold",
  900: "Black",
};
const FROALA_BASE = {
  placeholderText: "ADD TEXT HERE...",
  key: process.env.VUE_APP_FROALA_API_KEY,
  keepFormatOnDelete: true,
  fontSize: [
    "8",
    "9",
    "10",
    "11",
    "12",
    "13",
    "14",
    "15",
    "16",
    "17",
    "18",
    "19",
    "20",
    "22",
    "24",
    "26",
    "28",
    "30",
    "32",
    "34",
    "36",
    "38",
    "40",
    "42",
    "44",
    "46",
    "48",
    "50",
    "60",
    "72",
    "96",
  ],
  fontFamily: FONT_FAMILY,
  colorsText: [
    "#61BD6D",
    "#1ABC9C",
    "#54ACD2",
    "#2C82C9",
    "#9365B8",
    "#475577",
    "#CCCCCC",
    "#41A85F",
    "#00A885",
    "#3D8EB9",
    "#2969B0",
    "#553982",
    "#28324E",
    "#000000",
    "#F7DA64",
    "#FBA026",
    "#EB6B56",
    "#E25041",
    "#A38F84",
    "#EFEFEF",
    "#FFFFFF",
    "#FAC51C",
    "#F37934",
    "#D14841",
    "#B8312F",
    "#7C706B",
    "#D1D5D8",
    "#817E7E",
    "#4B4B5A",
    "#4A4848",
    "#808080",
    "REMOVE",
  ],
  tableCellMultipleStyles: false,
  tableInsertHelper: false,
  tableMultipleStyles: false,
  tableEditButtons: [],
  tableInsertButtons: [],
  linkEditButtons: [],
  linkInsertButtons: [],
  linkMultipleStyles: false,
  toolbarInline: false,
  toolbarVisibleWithoutSelection: true,
  charCounterCount: false,
  attribution: false,
  fileUpload: false,
  videoUpload: false,
  imageUpload: false,
  imageUploadURL: `${process.env.VUE_APP_BASE_API}api/v1/images/froala-image`,
  toolbarButtons: {},
  toolbarButtonsDefault: {
    moreText: {
      buttons: [
        "bold",
        "italic",
        "underline",
        "strikeThrough",
        "fontFamily",
        "fontSize",
        "paragraphFormat",
        "lineHeight",
        "textColor",
        "alignLeft",
        "alignCenter",
        "alignRight",
        "alignJustify",
        "indent",
        "outdent",
        "formatOL",
        "formatUL",
        "insertLink",
        "emoticons",
        "fontAwesome",
        "specialCharacters",
        "insertHR",
        "fullscreen",
        "html",
        "undo",
        "redo",
      ],
    },
  },
  toolbarButtonsImage: {
    moreText: {
      buttons: [
        "bold",
        "italic",
        "underline",
        "strikeThrough",
        "fontFamily",
        "fontSize",
        "paragraphFormat",
        "lineHeight",
        "textColor",
        "alignLeft",
        "alignCenter",
        "alignRight",
        "alignJustify",
        "indent",
        "outdent",
        "formatOL",
        "formatUL",
        "insertLink",
        "insertImage",
        "emoticons",
        "fontAwesome",
        "specialCharacters",
        "insertHR",
        "fullscreen",
        "html",
        "undo",
        "redo",
      ],
    },
  },
  lineHeights: {
    Default: "",
    Single: "1",
    1.1: "1.1",
    1.15: "1.15",
    1.3: "1.3",
    1.4: "1.4",
    1.5: "1.5",
    1.6: "1.6",
    1.7: "1.7",
    1.8: "1.8",
    Double: "2",
  },
  quickInsertButtons: ["table", "ul", "ol", "hr"],
};
const FROALA_DEFAULT_CONTENT =
  '<p class="default-fr-content">ADD TEXT HERE...</p>';
const FROALA_CONFIG2 = {
  ...FROALA_BASE,
  toolbarSticky: false,
  scrollableContainer: "#ne-preview-container",
  toolbarContainer: "#ne-editor-toolbar-2",
};
const FROALA_CONFIG = {
  ...FROALA_BASE,
  toolbarSticky: false,
  scrollableContainer: "#preview-container",
  toolbarContainer: "#classic-editor-toolbar",
};
const FROALA_CONFIG3 = {
  key: process.env.VUE_APP_FROALA_API_KEY,
  heightMin: 100,
  // heightMax: 450,
  quickInsertEnabled: false,
  toolbarVisibleWithoutSelection: false,
  useClasses: false,
  fontFamilySelection: true,
  fontSizeSelection: true,
  linkAlwaysBlank: true,
  linkStyles: {
    "fr-green": "Green",
    "fr-strong": "Thick",
    underlineClass: "Underline",
  },
  toolbarButtons: {
    moreText: {
      buttons: [
        "fontFamily",
        "fontSize",
        "textColor",
        "backgroundColor",
        "bold",
        "italic",
        "underline",
        "alignLeft",
        "alignCenter",
        "alignRight",
        "alignJustify",
        "insertLink",
        "emoticons",
        "formatUL",
        "formatOL",
        "lineHeight",
        "strikeThrough",
        "paragraphFormat",
        "paragraphStyle",
        "insertHR",
        "outdent",
        "indent",
        "quote",
        "undo",
        "redo",
        "fullscreen",
        "html",
      ],
      buttonsVisible: 10,
    },
  },
  emoticonsUseImage: false,
  requestHeaders: {
    Authorization: "Bearer " + localStorage.getItem("access_token"),
  },
};
const SECTIONPOPUP_SAMPLE = {
  show: true,
  ElementTitle: "",
  ShowCanvas: false,
  CanvasPosition: "top",
  CanvasHeight: "50%",
  CanvasBackgroundColor: "#F5EADE",
  PaddingLeft: "0",
  PaddingRight: "0",
  PaddingTop: "20",
  PaddingBottom: "20",
  MarginTop: "100",
  MarginBottom: "100",
  BoxShadow: null,
  ShowCloseIcon: true,
  BackDropBackgroundColor: "#00000066",
  BackgroundColor: "#FFFFFF",
  BackgroundVideo: null,
  OverlayBackgroundColor: "#FFFFFF00",
  BackgroundImage: "",
  BackgroundImagePosition: "fullcenterfit",
  BackgroundAttachment: null,
  BackgroundLazyLoad: true,
  EnableBackDrop: true,
  VerticalPosition: "top",
  Animation: "fade",
  AutomaticTrigger: null,
  TriggerDelay: "0",
  AllowFullWidth: false,
  Border: null,
  BorderStyle: "solid",
  BorderWidth: "1",
  BorderRadius: "0",
  BorderColor: "#00000000",
  RadiusEdge: "all",
  Width: "medium",
  Visibility: "both",
  elementSpecial: "popup",
};
const SECTION_SAMPLE = {
  show: true,
  ElementTitle: "",
  ShowCanvas: false,
  CanvasPosition: "top",
  CanvasHeight: "50%",
  CanvasBackgroundColor: "#F5EADE",
  PaddingLeft: "0",
  PaddingRight: "0",
  PaddingTop: "20",
  PaddingBottom: "20",
  MarginTop: "0",
  MarginBottom: "0",
  BoxShadow: null,
  BackgroundColor: "#FFFFFF00",
  BackgroundVideo: null,
  OverlayBackgroundColor: "#FFFFFF00",
  BackgroundImage: "",
  BackgroundImagePosition: "fullcenterfit",
  BackgroundAttachment: null,
  BackgroundLazyLoad: true,
  AllowFullWidth: false,
  Border: null,
  BorderStyle: "solid",
  BorderWidth: "1",
  BorderRadius: "0",
  BorderColor: "#00000000",
  TimeDelayType: null,
  TimeDelayMinute: 0,
  TimeDelaySecond: 0,
  RadiusEdge: 'all',
  Width: '',
  Visibility: 'both',
  HasBackgroundWrapper: false,
  HeaderMenuTotalHeight: false,
  ActiveSlider: 0,
  MainAnimationType: "fade-in",
  InnerElementAnimationType: "inherit",
  InnerElementAnimationSpeed: "normal-speed-animation",
  HeightSlider: 500,
  AutoSlider: 0,
  SliderDuration: 5,
};
const ROW_SAMPLE = {
  show: true,
  ElementTitle: "",
  ShowCanvas: false,
  CanvasPosition: "top",
  CanvasHeight: "50%",
  CanvasBackgroundColor: "#F5EADE",
  PaddingLeft: "0",
  PaddingRight: "0",
  PaddingTop: "15",
  PaddingBottom: "15",
  MarginTop: "0",
  MarginBottom: "0",
  InlineColumns: false,
  MobileColumnsOrder: "fromleft",
  Align: "center",
  BoxShadow: null,
  BackgroundColor: "#FFFFFF00",
  BackgroundImage: "",
  BackgroundImagePosition: "fullcenterfit",
  BackgroundAttachment: null,
  BackgroundLazyLoad: true,
  Border: null,
  BorderStyle: "solid",
  BorderWidth: "1",
  BorderRadius: "0",
  BorderColor: "#00000000",
  TimeDelayType: null,
  TimeDelayMinute: 0,
  TimeDelaySecond: 0,
  RadiusEdge: 'all',
  ContentWidth: 'ultrawide',
  Width: '100',
  Visibility: 'both',
  AnimationType: null,
  AnimationDelayTime: 0,
  AnimationDurationTime: 1,
  EnableSlider: false,
  ShowSlider: true,
  SliderBackgroundImage: "",
  InnerElementAnimationType: "",
  InnerElementAnimationSpeed: "normal-speed-animation",
  EnableHover: false,
  ActiveHover: false,
  IsEnableHoverFirstTime: false,
  HoverPaddingLeft: "0",
  HoverPaddingRight: "0",
  HoverPaddingTop: "15",
  HoverPaddingBottom: "15",
  HoverMarginTop: "0",
  HoverMarginBottom: "0",
  HoverAlign: "center",
  HoverBoxShadow: null,
  HoverBackgroundColor: "#FFFFFF00",
  HoverBackgroundImage: "",
  HoverBackgroundImagePosition: "fullcenterfit",
  HoverBackgroundAttachment: null,
  HoverBackgroundLazyLoad: true,
  IsOnHover: false,
};
const COLUMN_SAMPLE = {
  show: true,
  ElementTitle: "",
  OuterPaddingLeft: "0",
  OuterPaddingRight: "0",
  PaddingLeft: "15",
  PaddingRight: "15",
  PaddingTop: "10",
  PaddingBottom: "10",
  MarginTop: "0",
  MarginBottom: "0",
  BoxShadow: null,
  BackgroundColor: "#FFFFFF00",
  BackgroundImage: "",
  BackgroundImagePosition: "fullcenterfit",
  BackgroundAttachment: null,
  BackgroundLazyLoad: true,
  ContentAlignment: "vertical",
  ContentSpacing: "center",
  ContentPosition: "default",
  Border: null,
  BorderStyle: "solid",
  BorderWidth: "1",
  BorderRadius: "3",
  BorderColor: "#00000000",
  TimeDelayType: null,
  TimeDelayMinute: 0,
  TimeDelaySecond: 0,
  RadiusEdge: "all",
  Width: "100",
  Visibility: "both",
  EnableHover: false,
  IsEnableHoverFirstTime: false,
  ActiveHover: false,
  HoverOuterPaddingLeft: "0",
  HoverOuterPaddingRight: "0",
  HoverPaddingLeft: "15",
  HoverPaddingRight: "15",
  HoverPaddingTop: "10",
  HoverPaddingBottom: "10",
  HoverMarginTop: "0",
  HoverMarginBottom: "0",
  HoverBoxShadow: null,
  HoverBackgroundColor: "#FFFFFF00",
  HoverBackgroundImage: "",
  HoverBackgroundImagePosition: "fullcenterfit",
  HoverBackgroundAttachment: null,
  HoverBackgroundLazyLoad: true,
  HoverContentAlignment: 'vertical',
  HoverContentSpacing: 'center',
  HoverContentPosition: 'default',
  IsOnHover: false,
  AnimationType: null,
  AnimationDelayTime: 0,
  AnimationDurationTime: 1,
}
const BUTTON_SAMPLE = {
  Theme: "",
  BackgroundColor: "",
  TextColor: "",
  SubTextColor: "",
  BorderColor: "",
  PageId: null,
  SectionId: null,
  CustomLink: "",
  OpenInNewWindow: false,
  LinkDisabled: false,
  FontFamily: "'Poppins',sans-serif",
  Text: "",
  SubText: "",
  FontSize: "20",
  SubFontSize: "14",
  PaddingTop: "14",
  PaddingBottom: "14",
  PaddingLeft: "25",
  PaddingRight: "25",
  Width: "fluid",
  Alignment: "left",
  VerticalSpace: "14",
  HorizontalSpace: "25",
  ShowImage: false,
  Image:
    "https://net-engine.s3.us-east-2.amazonaws.com/landings/Px9mcm0ejWdbnW970R6yxRael3uWTfREfhFMj3XD.webp",
  ImageAlignment: "left",
  ShowWidth: "300",
  ShowHeight: "43",
  Border: "full",
  BorderStyle: "solid",
  BorderWidth: "1",
  BorderRadius: "3",
  RadiusEdge: "all",
  Icon: "",
  IconAfter: "",
  IconSize: "20",
  FontFamilyChanged: false,
};
const DEFAULT_THEME2 = {
  GlobalFontFamily: "'Poppins',sans-serif",
  BackgroundColor: "#FFFFFF",
  OverlayBackgroundColor: "#FFFFFF00",
  BackgroundImage: "",
  BackgroundImagePosition: "fullcenterfit",
};
const LANDING_ORIGINAL = {
  id: null,
  title: null,
  description: null,
  template: null,
  template_id: null,
  whitelabel: { domain: null },
  sections: [],
  defaultSections: [
    { key: "theme", label: "Quick Skins", component: "ThemeColors" },
  ],
  options: DigitalMarketingOptions,
  settings: {
    owner_section: {},
    business_section: {},
    socials: {},
    legals: {
      privacy: { label: "Privacy & Policy" },
      service: { label: "Terms of Services" },
    },
  },
};
const PAGE_ORIGINAL = {
  title: null,
  description: null,
  type: null,
  content: null,
  options: {
    banner: {
      Title: "The Easiest Tool To Convert Visitors & Leads Into Sales ",
      Content:
        "Engage website visitors using two-way text messaging and instant callback technology.",
      ButtonText: "Start Your Free 14 Day Trial",
      ButtonHelper: "Create your account and start connecting today!",
      ButtonLink: null,
      Image: "https://net-engine.s3.us-east-2.amazonaws.com/assets/page-1.webp",
    },
    services: {
      Title: "Here Is What Our Software Does",
      Content:
        "We Provide Everything You Need To Grow Your Marketing Agencies Recurring Revenue",
      Items: [
        {
          Name: "Eye Catching Button",
          Title:
            "Grab Your Website Visitors Attention & Convert Them To A Sales Conversations",
          Content:
            "Add a text & phone button to your website in just a few seconds. Connect your hot leads to your sales people in 15 seconds or less.",
          Features: [
            {
              value:
                "Animated call button to attract more attention to your website visitors",
            },
            {
              value:
                "Our Artificial Intelligence (AI) automatically pops up at the ideal time when they are likely to convert",
            },
            { value: "Customize the text and colors to match your branding" },
          ],
          Img: "https://net-engine.s3.us-east-2.amazonaws.com/assets/page-2.webp",
        },
        {
          Name: "Customizable Multi Channel Widget",
          Title: "Engage Your Website Visitors On Their Own Terms",
          Content:
            "Your website visitors can choose to connect via text message or an instant callback using our multi channel communication widget",
          Features: [
            { value: "Customize the colors, content and logo" },
            {
              value:
                "Customize to your needs by choosing phone & text, text only or phone only",
            },
            {
              value:
                "​Using micro commitments increases the conversion rate and generates more hot leads",
            },
          ],
          Img: "https://net-engine.s3.us-east-2.amazonaws.com/assets/page-3.webp",
        },
        {
          Name: "Web Text Chat - Conversations That Convert",
          Title:
            "Boost Sales By Connecting With Visitors Through Text Messaging Chat!",
          Content:
            "Next generation chat for your website, capture and convert leads by allowing them to enter their mobile number and question and move the to a text conversation.",
          Features: [
            {
              value:
                "Keep the conversation going after your visitor has left your website",
            },
            { value: "Text enable your existing landline" },
            { value: "Auto-replies for outside of business hours" },
          ],
          Img: "https://net-engine.s3.us-east-2.amazonaws.com/assets/page-4.webp",
        },
        {
          Name: "Instant Callback",
          Title:
            "Increase Conversions & Turn Website Visitors Into Sales Calls!",
          Content:
            "Maximize your marketing spend by engaging with your visitors at the ideal time. Our widget seamlessly connects visitors to your sales team in 15 seconds. ",
          Features: [
            { value: "Increase conversion rates on your website" },
            { value: "Record conversations to improve customer service" },
            { value: "Generate more sales leads on complete auto-pilot" },
          ],
          Img: "https://net-engine.s3.us-east-2.amazonaws.com/assets/page-5.webp",
        },
      ],
    },
    about: {
      Active: true,
      Content:
        "Zach Anderson is one of those people that I trust when it comes to building software that grows my digital agency or my informational business",
      Name: "Dr. Ben Adkins",
      Position: "CEO Serial Progress Seeker",
      Video: "https://vimeo.com/389527109",
      Image: null,
    },
    trial: {
      Active: true,
      Title:
        "With our multi-channel AI powered communication widget you can stop chasing leads and start closing deals instantly turning website visitors into customers",
      Content:
        "Convert website traffic to sales instantly with our multi-channel lead engagement software. This new technology lets you build on high-value engagements – creating a unique experience for prospects and customers.",
      ButtonText: "Start Your Free Trial Today!",
      ButtonHelper: "Get More Leads & Customers Right now!",
      ButtonLink: null,
    },
  },
};
const WIDTH_OPTIONS = {
  ultrawide: "Ultra Wide",
  fullwidth: "Full Width",
  wide: "Wide",
  medium: "Medium",
  small: "Small",
  mobile: "Mobile",
};
const BLOCK_TYPES = {
  header: "Header",
  menu: "Menu",
  footer: "Footer",
  about: "About",
  contact: "Contact",
  transition: "Transition",
};
const HOVER_EFFECTS = {
  "hvr-grow": "Grow",
  "hvr-shrink": "Shrink",
  "hvr-pulse": "Pulse",
  "hvr-pulse-grow": "Pulse Grow",
  "hvr-pulse-shrink": "Pulse Shrink",
  "hvr-push": "Push",
  "hvr-pop": "Pop",
  "hvr-bounce-in": "Bounce In",
  "hvr-bounce-out": "Bounce Out",
  "hvr-rotate": "Rotate",
  "hvr-grow-rotate": "Grow Rotate",
  "hvr-float": "Float",
  "hvr-sink": "Sink",
  "hvr-bob": "Bob",
  "hvr-hang": "Hang",
  "hvr-skew": "Skew",
  "hvr-skew-forward": "Skew Forward",
  "hvr-skew-backward": "Skew Backward",
  "hvr-wobble-horizontal": "Wobble Horizontal",
  "hvr-wobble-vertical": "Wobble Vertical",
  "hvr-wobble-to-bottom-right": "Wobble To Bottom Right",
  "hvr-wobble-to-top-right": "Wobble To Top Right",
  "hvr-wobble-top": "Wobble Top",
  "hvr-wobble-bottom": "Wobble Bottom",
  "hvr-wobble-skew": "Wobble Skew",
  "hvr-buzz": "Buzz",
  "hvr-buzz-out": "Buzz Out",
  "hvr-forward": "Forward",
  "hvr-backward": "Backward",
};
const GALLERY_TYPES = {
  slide: "Default Slider",
  coverflow: "Coverflow Slider",
  card: "Card Slider",
  creative: "Creative Slider",
  standardGallery: "Standard Gallery",
  masonryGallery: "Masonry Gallery",
};
const GALLERY_KINDS = {
  slide: ["slide", "coverflow", "card", "creative"],
  gallery: ["standardGallery", "masonryGallery"],
};
const REVIEW_LAYOUTS = {
  grid: "Grid",
  masonry: "Masonry",
  list: "List",
  carousel: "Carousel",
};
const YOUTUBE_LAYOUTS = {
  carousel: "Carousel",
  grid: "Grid",
};

const PODCAST_LAYOUTS = {
  carousel: "Carousel",
  grid: "Grid",
};

const INPUT_THEMES = [
  { label: "Default Input", name: "default" },
  { label: "Gray Border Input", name: "gray" },
  { label: "Light Gray Input", name: "lightgray" },
  { label: "Border White Input", name: "borderwhite" },
  { label: "Simple Input", name: "simple" },
  { label: "3D Gradient Input", name: "3dgradient" },
  { label: "Simple Clean Input", name: "simpleclean" },
  { label: "Black Underline Input", name: "blackunderline" },
];
const BUTTON_THEMES = [
  { label: "3d Button", name: "3d" },
  { label: "Square Button", name: "square" },
  { label: "5pt Corner Button", name: "5pt-corner" },
  { label: "10pt Corner Button", name: "10pt-corner" },
  { label: "15pt Corner Button", name: "15pt-corner" },
  { label: "20pt Corner Button", name: "20pt-corner" },
  { label: "Pill Button", name: "pill" },
];
const BOX_SHADOWS = [
  { label: "No Shadow", value: null },
  { label: "5% Drop Shadow", value: "ne-shadow5" },
  { label: "10% Drop Shadow", value: "ne-shadow10" },
  { label: "20% Drop Shadow", value: "ne-shadow20" },
  { label: "30% Drop Shadow", value: "ne-shadow30" },
  { label: "40% Drop Shadow", value: "ne-shadow40" },
  { label: "5% Inner Shadow", value: "ne-shadow5inner" },
  { label: "10% Inner Shadow", value: "ne-shadow10inner" },
  { label: "20% Inner Shadow", value: "ne-shadow20inner" },
  { label: "30% Inner Shadow", value: "ne-shadow30inner" },
  { label: "40% Inner Shadow", value: "ne-shadow40inner" },
];
const BORDER_OPTIONS = [
  { label: "No Border", value: null },
  { label: "Full Border", value: "full" },
  { label: "Top Border", value: "top" },
  { label: "Bottom Border", value: "bottom" },
  { label: "Top & Bottom Border", value: "topbottom" },
  { label: "Left Border", value: "left" },
  { label: "Right Border", value: "right" },
  { label: "Left & Right Border", value: "leftright" },
];
const BORDER_STYLES = {
  solid: "Solid",
  dashed: "Dashed",
  dotted: "Dotted",
};
const TIMEDELAY_OPTIONS = [
  { label: "No Delay", value: null },
  { label: "Fade In", value: "fadein" },
];
const SLIDER_MAIN_ANIMATION_OPTIONS = [
  { label: "Fade", value: "fade-in" },
  { label: "Carousel", value: "slide-in-right-fifty" },
];

const SLIDER_INNER_ELEMENT_ANIMATION_OPTIONS = [
  { label: "No", value: null },
  { label: "Slide In Left", value: "slide-in-left" },
  { label: "Slide In Right", value: "slide-in-right" },
  { label: "Slide In Top", value: "slide-in-top" },
  { label: "Slide In Bottom", value: "slide-in-bottom" },
];

const SLIDER_INNER_ELEMENT_ANIMATION_OPTIONS1 = [
  { label: "Inherit", value: "inherit" },
  ...SLIDER_INNER_ELEMENT_ANIMATION_OPTIONS,
];

const SLIDER_INNER_ELEMENT_ANIMATION_SPEED_OPTIONS = [
  { label: "Slow", value: "slow-speed-animation" },
  { label: "Normal", value: "normal-speed-animation" },
  { label: "Fast", value: "fast-speed-animation" },
];

const SLIDER_INNER_ELEMENT_ANIMATION_SPEED_OPTIONS1 = [
  { label: "Inherit", value: "inherit" },
  ...SLIDER_INNER_ELEMENT_ANIMATION_SPEED_OPTIONS,
];

const RADIUS_EDGES = {
  all: "All Edges",
  toponly: "Top Only Edges",
  bottomonly: "Bottom Only Edges",
};
const BG_POSITIONS = {
  fullcenterfit: "Full Center Fit",
  fullcenterparallax: "Full Center (Parallax)",
  fillwidth: "Fill 100% Width",
  norepeat: "No Repeat",
  repeat: "Repeat",
  repeatH: "Repeat Horizontally",
  repeatV: "Repeat Vertically",
  repeatHTop: "Repeat Horizontally - Top",
  repeatHBottom: "Repeat Horizontally - Bottom",
};
const TIME_OPTIONS = [
  { label: "12 AM", value: "00" },
  { label: "1 AM", value: "01" },
  { label: "2 AM", value: "02" },
  { label: "3 AM", value: "03" },
  { label: "4 AM", value: "04" },
  { label: "5 AM", value: "05" },
  { label: "6 AM", value: "06" },
  { label: "7 AM", value: "07" },
  { label: "8 AM", value: "08" },
  { label: "9 AM", value: "09" },
  { label: "10 AM", value: "10" },
  { label: "11 AM", value: "11" },
  { label: "12 PM", value: "12" },
  { label: "1 PM", value: "13" },
  { label: "2 PM", value: "14" },
  { label: "3 PM", value: "15" },
  { label: "4 PM", value: "16" },
  { label: "5 PM", value: "17" },
  { label: "6 PM", value: "18" },
  { label: "7 PM", value: "19" },
  { label: "8 PM", value: "20" },
  { label: "9 PM", value: "21" },
  { label: "10 PM", value: "22" },
  { label: "11 PM", value: "23" },
];
const TIMEZONES = [
  { label: "EST", value: "America/New_York" },
  { label: "PST", value: "America/Los_Angeles" },
  { label: "CST", value: "America/Chicago" },
  { label: "MST", value: "America/Denver" },
];
const SHADOW_THEMES = [
  "default",
  "shadow1",
  "shadow2",
  "shadow3",
  "shadow4",
  "shadow5",
  "shadow6",
  "shadow7",
  "shadow8",
  "shadow9",
];
const ICON_THEMES = [
  { key: "default", label: "Default" },
  { key: "text-shadow", label: "Simple Shadow" },
  { key: "boxed", label: "Boxed" },
  { key: "circle", label: "Circle" },
  { key: "blue-boxed", label: "Blue Boxed" },
  { key: "green-boxed", label: "Green Boxed" },
  { key: "red-boxed", label: "Red Boxed" },
  { key: "yellow-boxed", label: "Yellow Boxed" },
  { key: "gray-boxed", label: "Gray Boxed" },
  { key: "purple-boxed", label: "Purple Boxed" },
  { key: "dark-boxed", label: "Dark Boxed" },
];
const TIMER_THEMES = [
  "default",
  "blue",
  "green",
  "red",
  "blackcircle",
  "bluecircle",
  "greencircle",
  "redcircle",
  "yellowcircle",
  "blackrect",
  "bluerect",
  "greenrect",
  "redrect",
  "yellowrect",
  "blackrectshadow",
  "bluerectshadow",
  "greenrectshadow",
  "redrectshadow",
  "yellowrectshadow",
  "blackcircleoutline",
  "bluecircleoutline",
  "greencircleoutline",
  "redcircleoutline",
  "yellowcircleoutline",
];
const ELEMENT_CATEGORIES = {
  all: "All",
  text: "Text",
  form: "Form",
  order: "Order",
  media: "Media",
  countdown: "Countdown",
  misc: "Misc",
};
const ALL_ELEMENTS = {
  titleHeadline2: {
    label: "Headline",
    icon: "fa-sharp fa-regular fa-heading",
    prefix: "headline",
    category: "text",
  },
  header1: {
    label: "H1",
    icon: "fa-sharp fa-regular fa-h1",
    prefix: "header1",
    category: "text",
  },
  header2: {
    label: "H2",
    icon: "fa-sharp fa-regular fa-h2",
    prefix: "header2",
    category: "text",
  },
  header3: {
    label: "H3",
    icon: "fa-sharp fa-regular fa-h3",
    prefix: "header3",
    category: "text",
  },
  subHeadline2: {
    label: "Sub Headline",
    icon: "fa-sharp fa-regular fa-font",
    prefix: "subheadline",
    category: "text",
  },
  paragraph2: {
    label: "Paragraph",
    icon: "fa-sharp fa-regular fa-paragraph",
    category: "text",
  },
  bulletList: {
    label: "Bullet List",
    icon: "fa-sharp fa-regular fa-list-ul",
    prefix: "bulletlist",
    category: "text",
  },
  faq2: {
    label: "FAQ",
    icon: "fa-sharp fa-regular fa-circle-question",
    category: "text",
  },
  button: {
    label: "Button",
    icon: "fa-sharp fa-regular fa-hand-pointer",
    category: "form",
  },
  checkbox: {
    label: "Checkbox",
    icon: "fa-sharp fa-regular fa-square-check",
    category: "form",
  },
  dropdown: {
    label: "Dropdown",
    icon: "fa-sharp fa-regular fa-list-dropdown",
    category: "form",
  },
  input: {
    label: "Input",
    icon: "fa-sharp fa-regular fa-input-text",
    category: "form",
  },
  textarea: {
    label: "Text Area",
    icon: "fa-sharp fa-regular fa-message-text",
    category: "form",
  },
  form: {
    label: "Form",
    icon: "fa-brands fa-wpforms",
    category: "form",
  },
  coupon: {
    label: "Coupon",
    icon: "fa-sharp fa-regular fa-badge-dollar",
    category: "order",
  },
  creditCard: {
    label: "Credit Card",
    icon: "fa-sharp fa-regular fa-credit-card",
    prefix: "creditcard",
    category: "order",
  },
  orderSelect: {
    label: "Order Select",
    icon: "fa-sharp fa-regular fa-money-bill-1",
    prefix: "orderselect",
    category: "order",
  },
  orderSummary: {
    label: "Order Summary",
    icon: "fa-sharp fa-regular fa-money-check-dollar",
    prefix: "ordersummary",
    category: "order",
  },
  stripeLink: {
    label: "Stripe Link",
    icon: "fa-brands fa-cc-stripe",
    prefix: "stripe-link",
    category: "order",
  },
  neAudio: {
    label: "Audio",
    icon: "fa-sharp fa-regular fa-volume-up",
    prefix: "audio",
    category: "media",
  },
  neVideo: {
    label: "Video",
    icon: "fa-sharp fa-regular fa-video",
    prefix: "video",
    category: "media",
  },
  neImage: {
    label: "Image",
    icon: "fa-sharp fa-regular fa-image",
    prefix: "image",
    category: "media",
  },
  photoGallery: {
    label: "Gallery",
    icon: "fa-sharp fa-regular fa-photo-film",
    prefix: "gallery",
    category: "media",
  },
  youtubeGallery: {
    label: "Youtube Gallery",
    icon: "fa-brands fa-youtube",
    prefix: "youtube",
    category: "media",
  },
  podcastGallery: {
    label: "Podcast Gallery",
    icon: "fa-solid fa-tower-broadcast",
    prefix: "podcast",
    category: "media",
  },
  blog2: {
    label: "Blog",
    icon: "fa-sharp fa-light fa-blog",
    prefix: "blog",
    category: "media",
  },
  countdown: {
    label: "Countdown",
    icon: "fa-sharp fa-regular fa-hourglass-clock",
    category: "countdown",
  },
  numberCounter: {
    label: 'Number Counter',
    icon: 'fa-sharp fa-regular fa-stairs',
    category: 'countdown'
  },
  minuteTimer: {
    label: "Minute Timer",
    icon: "fa-sharp fa-regular fa-timer",
    prefix: "minute-timer",
    category: "countdown",
  },
  dayTimer: {
    label: "Day Timer",
    icon: "fa-sharp fa-regular fa-alarm-clock",
    prefix: "day-timer",
    category: "countdown",
  },
  locationMap: {
    label: "Google Map",
    icon: "fa-sharp fa-regular fa-map-location",
    prefix: "map",
    category: "misc",
  },
  googleReview: {
    label: "Google Review",
    icon: "fa-sharp fa-regular fa-stars",
    prefix: "review",
    category: "misc",
  },
  goToInfo: {
    label: "GoTo Reg Info",
    icon: "fa-sharp fa-regular fa-calendar-lines-pen",
    prefix: "goto-info",
    category: "misc",
  },
  htmlEditor: {
    label: "HTML Editor",
    icon: "fa-sharp fa-regular fa-code",
    prefix: "editor",
    category: "misc",
  },
  neIcon: {
    label: "Icon",
    icon: "fa-sharp fa-regular fa-bar-chart",
    prefix: "icon",
    category: "misc",
  },
  neIconFeature: {
    label: "Icon Feature",
    icon: "fa-brands fa-fonticons",
    prefix: "iconfeature",
    category: "misc",
  },
  neImageFeature: {
    label: "Img Feature",
    icon: "fa-sharp fa-regular fa-images",
    prefix: "imgfeature",
    category: "misc",
  },
  // neImageFeature2: {
  //   label: 'Img Feature 2',
  //   icon: 'fa-duotone fa-images',
  //   prefix: 'imgfeature2',
  //   category: 'misc'
  // },
  navigation: {
    label: "Navigation",
    icon: "fa-sharp fa-regular fa-bars",
    category: "misc",
  },
  socialLink: {
    label: "Social Link",
    icon: "fa-sharp fa-regular fa-external-link-square",
    prefix: "sociallink",
    category: "misc",
  },
  socialSharing: {
    label: "Social Sharing",
    icon: "fa-brands fa-facebook-f",
    prefix: "social",
    category: "misc",
  },
};
const FORM_INPUTS = {
  fullName: {
    label: "Full Name",
    type: "text",
    placeholder: "Full Name",
    required: true,
  },
  firstName: {
    label: "First Name",
    type: "text",
    placeholder: "First Name",
    required: true,
  },
  lastName: {
    label: "Last Name",
    type: "text",
    placeholder: "Last Name",
    required: true,
  },
  phone: {
    label: "Phone",
    type: "phone",
    placeholder: "Phone",
    required: false,
  },
  email: {
    label: "Email",
    type: "email",
    placeholder: "Email",
    required: true,
  },
  address: {
    label: "Address",
    type: "text",
    placeholder: "Address",
    required: true,
  },
  city: { label: "City", type: "text", placeholder: "City", required: true },
  state: { label: "State", type: "text", placeholder: "State", required: true },
  postalCode: {
    label: "Postal Code",
    type: "text",
    placeholder: "Postal Code",
    required: false,
  },
};
const STRIPE_INTERVAL = {
  day: "Daily",
  week: "Weekly",
  month: "Monthly",
  year: "Yearly",
};
const CARD_ICONS = [
  { id: "email", label: "Email", img: "mail.webp", active: true },
  { id: "text", label: "Text", img: "text.webp", active: true },
  { id: "call", label: "Phone", img: "phone.webp", active: true },
  { id: "facebook", label: "Facebook", img: "facebook.webp", active: true },
  { id: "whatsapp", label: "Whatsapp", img: "whatsapp.webp", active: true },
  { id: "contact", label: "Contacts", img: "contacts.webp", active: true },
  { id: "facetime", label: "Facetime", img: "facetime.webp", active: true },
  { id: "website", label: "Website", img: "safari.webp", active: true },
  { id: "linkedin", label: "LinkedIn", img: "linkedin.webp", active: true },
  { id: "instagram", label: "Instagram", img: "instagram.webp", active: true },
  { id: "twitter", label: "X (Twitter)", img: "x.webp", active: true },
  { id: "youtube", label: "YouTube", img: "youtube.webp", active: true },
  { id: "tiktok", label: "TikTok", img: "tiktok.webp", active: true },
  { id: "snapchat", label: "SnapChat", img: "snapchat.webp", active: true },
];
const DEFAULT_CARD_ICON = [
  { id: "email", label: "Email", img: "mail.webp", active: true },
  { id: "text", label: "Text", img: "text.webp", active: true },
  { id: "call", label: "Phone", img: "phone.webp", active: true },
];
const CARD_DESIGNS = [
  { id: "design1", label: "Modern" },
  { id: "design2", label: "Classic" },
  { id: "design3", label: "Sleek" },
  { id: "design4", label: "Elegant" },
];
const DEFAULT_CARD_FIELDS = [
  {
    id: "fullname",
    label: "Full Name",
    type: "string",
    active: true,
    required: true,
  },
  {
    id: "company",
    label: "Company",
    type: "string",
    active: true,
    required: true,
  },
  { id: "email", label: "Email", type: "email", active: true, required: true },
  { id: "phone", label: "Phone", type: "phone", active: true, required: true },
  { id: "note", label: "Notes", type: "text", active: true, required: true },
];
const CARD_FIELDS = [
  {
    id: "fullname",
    label: "Full Name",
    type: "string",
    active: true,
    required: true,
  },
  { id: "email", label: "Email", type: "email", active: true, required: true },
  { id: "phone", label: "Phone", type: "phone", active: true, required: true },
  {
    id: "company",
    label: "Company",
    type: "string",
    active: true,
    required: true,
  },
  {
    id: "job",
    label: "Job Title",
    type: "string",
    active: true,
    required: true,
  },
  { id: "note", label: "Notes", type: "text", active: true, required: true },
];
const CARD_COLORS = [
  { id: "violet", color: "#8F60DE", secondaryColor: "#f0eafb" },
  { id: "denim", color: "#3A59AE", secondaryColor: "#DBE0F0" },
  { id: "sky", color: "#628AF8", secondaryColor: "#eaeffe" },
  { id: "beach", color: "#6DD3C7", secondaryColor: "#edf9f8" },
  { id: "thyme", color: "#3BB55D", secondaryColor: "#e7f5ea" },
  { id: "banana", color: "#faa810", secondaryColor: "#fef5e4" },
  { id: "tangerine", color: "#FF8C39", secondaryColor: "#ffefe6" },
  { id: "tomato", color: "#EA3A2E", secondaryColor: "#fee6e4" },
  { id: "doughnut", color: "#EE85DD", secondaryColor: "#feeefb" },
  { id: "gravel", color: "#4A4A4A", secondaryColor: "#e7e7e7" },
];
const DEFAULT_CARD = {
  options: {
    Align: "left",
    Button: {
      Theme: "pill",
      HoverAnimation: "hvr-grow",
      Label: "Save Contact",
    },
    IconInline: true,
    IconList: [...DEFAULT_CARD_ICON],
    ShowLeadForm: true,
    CloseOnBackdropClick: false,
    LeadForm: {
      ButtonLabel: "Connect",
      Headline: "Share your info back with",
      Disclosure: "We do not sell or share your data.",
    },
    FieldList: [...DEFAULT_CARD_FIELDS],
    ButtonList: [],
    Design: {
      Id: "design1",
      ColorTheme: "denim",
      Color: "#3A59AE",
      SecondaryColor: "#DBE0F0",
    },
    Integrations: {},
    Powerby: {
      Enabled: false,
      Business: "Business Name",
      Url: "",
    },
    Redirect: {
      Enabled: false,
      NewTab: false,
      Url: "",
      Title: "Your Title Goes Here",
      Content: "Your descriptions goes here",
      ButtonLabel: "Click Here",
    },
    CustomUrl: {
      Enabled: false,
    },
  },
  smart_ids: [],
}

const ANIMATION_OPTIONS = [
  { label: 'No', value: null },
  { label: 'In Left', value: 'in-left' },
  { label: 'In Right', value: 'in-right' },
  { label: 'In Top', value: 'in-top' },
  { label: 'In Bottom', value: 'in-bottom' },
]

const windowsToIanaMap = {
  "Dateline Standard Time": "Etc/GMT+12",
  "UTC-11": "Etc/GMT+11",
  "Hawaiian Standard Time": "Pacific/Honolulu",
  "Alaskan Standard Time": "America/Anchorage",
  "Pacific Standard Time (Mexico)": "America/Tijuana",
  "Pacific Standard Time": "America/Los_Angeles",
  "Mountain Standard Time (Mexico)": "America/Chihuahua",
  "Mountain Standard Time": "America/Denver",
  "Central America Standard Time": "America/Guatemala",
  "Central Standard Time": "America/Chicago",
  "Central Standard Time (Mexico)": "America/Mexico_City",
  "Canada Central Standard Time": "America/Regina",
  "SA Pacific Standard Time": "America/Bogota",
  "Eastern Standard Time": "America/New_York",
  "US Eastern Standard Time": "America/Indiana/Indianapolis",
  "Venezuela Standard Time": "America/Caracas",
  "Paraguay Standard Time": "America/Asuncion",
  "Atlantic Standard Time": "America/Halifax",
  "Central Brazilian Standard Time": "America/Cuiaba",
  "SA Western Standard Time": "America/La_Paz",
  "Pacific SA Standard Time": "America/Santiago",
  "Newfoundland Standard Time": "America/St_Johns",
  "E. South America Standard Time": "America/Sao_Paulo",
  "Argentina Standard Time": "America/Buenos_Aires",
  "SA Eastern Standard Time": "America/Cayenne",
  "Greenland Standard Time": "America/Godthab",
  "Montevideo Standard Time": "America/Montevideo",
  "Bahia Standard Time": "America/Bahia",
  "UTC-02": "Etc/GMT+2",
  "Mid-Atlantic Standard Time": "Etc/GMT+2",
  "Azores Standard Time": "Atlantic/Azores",
  "Cape Verde Standard Time": "Atlantic/Cape_Verde",
  "Morocco Standard Time": "Africa/Casablanca",
  UTC: "Etc/UTC",
  "GMT Standard Time": "Europe/London",
  "Greenwich Standard Time": "Atlantic/Reykjavik",
  "W. Europe Standard Time": "Europe/Berlin",
  "Central Europe Standard Time": "Europe/Budapest",
  "Romance Standard Time": "Europe/Paris",
  "Central European Standard Time": "Europe/Sarajevo",
  "W. Central Africa Standard Time": "Africa/Lagos",
  "Jordan Standard Time": "Asia/Amman",
  "GTB Standard Time": "Europe/Athens",
  "Middle East Standard Time": "Asia/Beirut",
  "Egypt Standard Time": "Africa/Cairo",
  "E. Europe Standard Time": "Europe/Chisinau",
  "Syria Standard Time": "Asia/Damascus",
  "West Bank Standard Time": "Asia/Hebron",
  "South Africa Standard Time": "Africa/Johannesburg",
  "FLE Standard Time": "Europe/Kiev",
  "Israel Standard Time": "Asia/Jerusalem",
  "Kaliningrad Standard Time": "Europe/Kaliningrad",
  "Sudan Standard Time": "Africa/Khartoum",
  "Libya Standard Time": "Africa/Tripoli",
  "Arabic Standard Time": "Asia/Baghdad",
  "Arab Standard Time": "Asia/Riyadh",
  "E. Africa Standard Time": "Africa/Nairobi",
  "Iran Standard Time": "Asia/Tehran",
  "Arabian Standard Time": "Asia/Dubai",
  "Azerbaijan Standard Time": "Asia/Baku",
  "Russia Time Zone 3": "Europe/Samara",
  "Mauritius Standard Time": "Indian/Mauritius",
  "Georgian Standard Time": "Asia/Tbilisi",
  "Caucasus Standard Time": "Asia/Yerevan",
  "Afghanistan Standard Time": "Asia/Kabul",
  "West Asia Standard Time": "Asia/Tashkent",
  "Pakistan Standard Time": "Asia/Karachi",
  "India Standard Time": "Asia/Kolkata",
  "Sri Lanka Standard Time": "Asia/Colombo",
  "Nepal Standard Time": "Asia/Kathmandu",
  "Central Asia Standard Time": "Asia/Almaty",
  "Bangladesh Standard Time": "Asia/Dhaka",
  "Myanmar Standard Time": "Asia/Yangon",
  "SE Asia Standard Time": "Asia/Bangkok",
  "N. Central Asia Standard Time": "Asia/Novosibirsk",
  "China Standard Time": "Asia/Shanghai",
  "North Asia Standard Time": "Asia/Krasnoyarsk",
  "Singapore Standard Time": "Asia/Singapore",
  "W. Australia Standard Time": "Australia/Perth",
  "Taipei Standard Time": "Asia/Taipei",
  "Ulaanbaatar Standard Time": "Asia/Ulaanbaatar",
  "North Asia East Standard Time": "Asia/Irkutsk",
  "Japan Standard Time": "Asia/Tokyo",
  "Korea Standard Time": "Asia/Seoul",
  "Cen. Australia Standard Time": "Australia/Adelaide",
  "AUS Central Standard Time": "Australia/Darwin",
  "E. Australia Standard Time": "Australia/Brisbane",
  "AUS Eastern Standard Time": "Australia/Sydney",
  "West Pacific Standard Time": "Pacific/Port_Moresby",
  "Tasmania Standard Time": "Australia/Hobart",
  "Yakutsk Standard Time": "Asia/Yakutsk",
  "Vladivostok Standard Time": "Asia/Vladivostok",
  "Central Pacific Standard Time": "Pacific/Guadalcanal",
  "New Zealand Standard Time": "Pacific/Auckland",
  "UTC+12": "Etc/GMT-12",
  "Fiji Standard Time": "Pacific/Fiji",
  "Magadan Standard Time": "Asia/Magadan",
  "Tonga Standard Time": "Pacific/Tongatapu",
  "Samoa Standard Time": "Pacific/Apia",
  "Line Islands Standard Time": "Pacific/Kiritimati",
};

const windowsTimezones = [
  {
    value: "Dateline Standard Time",
    text: "(UTC-12:00) International Date Line West",
  },
  { value: "UTC-11", text: "(UTC-11:00) Coordinated Universal Time-11" },
  { value: "Hawaiian Standard Time", text: "(UTC-10:00) Hawaii" },
  { value: "Alaskan Standard Time", text: "(UTC-09:00) Alaska" },
  {
    value: "Pacific Standard Time (Mexico)",
    text: "(UTC-08:00) Baja California",
  },
  {
    value: "Pacific Standard Time",
    text: "(UTC-08:00) Pacific Time (US & Canada)",
  },
  {
    value: "Mountain Standard Time (Mexico)",
    text: "(UTC-07:00) Chihuahua, La Paz, Mazatlan",
  },
  {
    value: "Mountain Standard Time",
    text: "(UTC-07:00) Mountain Time (US & Canada)",
  },
  {
    value: "Central America Standard Time",
    text: "(UTC-06:00) Central America",
  },
  {
    value: "Central Standard Time",
    text: "(UTC-06:00) Central Time (US & Canada)",
  },
  {
    value: "Central Standard Time (Mexico)",
    text: "(UTC-06:00) Guadalajara, Mexico City, Monterrey",
  },
  { value: "Canada Central Standard Time", text: "(UTC-06:00) Saskatchewan" },
  {
    value: "SA Pacific Standard Time",
    text: "(UTC-05:00) Bogota, Lima, Quito",
  },
  {
    value: "Eastern Standard Time",
    text: "(UTC-05:00) Eastern Time (US & Canada)",
  },
  { value: "US Eastern Standard Time", text: "(UTC-05:00) Indiana (East)" },
  { value: "Venezuela Standard Time", text: "(UTC-04:30) Caracas" },
  { value: "Paraguay Standard Time", text: "(UTC-04:00) Asuncion" },
  {
    value: "Atlantic Standard Time",
    text: "(UTC-04:00) Atlantic Time (Canada)",
  },
  { value: "Central Brazilian Standard Time", text: "(UTC-04:00) Cuiaba" },
  {
    value: "SA Western Standard Time",
    text: "(UTC-04:00) Georgetown, La Paz, Manaus, San Juan",
  },
  { value: "Pacific SA Standard Time", text: "(UTC-04:00) Santiago" },
  { value: "Newfoundland Standard Time", text: "(UTC-03:30) Newfoundland" },
  { value: "E. South America Standard Time", text: "(UTC-03:00) Brasilia" },
  { value: "Argentina Standard Time", text: "(UTC-03:00) Buenos Aires" },
  { value: "SA Eastern Standard Time", text: "(UTC-03:00) Cayenne, Fortaleza" },
  { value: "Greenland Standard Time", text: "(UTC-03:00) Greenland" },
  { value: "Montevideo Standard Time", text: "(UTC-03:00) Montevideo" },
  { value: "Bahia Standard Time", text: "(UTC-03:00) Salvador" },
  { value: "UTC-02", text: "(UTC-02:00) Coordinated Universal Time-02" },
  { value: "Mid-Atlantic Standard Time", text: "(UTC-02:00) Mid-Atlantic" },
  { value: "Azores Standard Time", text: "(UTC-01:00) Azores" },
  { value: "Cape Verde Standard Time", text: "(UTC-01:00) Cape Verde Is." },
  { value: "Morocco Standard Time", text: "(UTC+00:00) Casablanca" },
  { value: "UTC", text: "(UTC+00:00) Coordinated Universal Time" },
  {
    value: "GMT Standard Time",
    text: "(UTC+00:00) Dublin, Edinburgh, Lisbon, London",
  },
  { value: "Greenwich Standard Time", text: "(UTC+00:00) Monrovia, Reykjavik" },
  {
    value: "W. Europe Standard Time",
    text: "(UTC+01:00) Amsterdam, Berlin, Bern, Rome, Stockholm, Vienna",
  },
  {
    value: "Central Europe Standard Time",
    text: "(UTC+01:00) Belgrade, Bratislava, Budapest, Ljubljana, Prague",
  },
  {
    value: "Romance Standard Time",
    text: "(UTC+01:00) Brussels, Copenhagen, Madrid, Paris",
  },
  {
    value: "Central European Standard Time",
    text: "(UTC+01:00) Sarajevo, Skopje, Warsaw, Zagreb",
  },
  {
    value: "W. Central Africa Standard Time",
    text: "(UTC+01:00) West Central Africa",
  },
  { value: "Jordan Standard Time", text: "(UTC+02:00) Amman" },
  {
    value: "GTB Standard Time",
    text: "(UTC+02:00) Athens, Bucharest, Istanbul",
  },
  { value: "Middle East Standard Time", text: "(UTC+02:00) Beirut" },
  { value: "Egypt Standard Time", text: "(UTC+02:00) Cairo" },
  { value: "E. Europe Standard Time", text: "(UTC+02:00) Chisinau" },
  { value: "Syria Standard Time", text: "(UTC+02:00) Damascus" },
  { value: "West Bank Standard Time", text: "(UTC+02:00) Gaza" },
  { value: "South Africa Standard Time", text: "(UTC+02:00) Harare, Pretoria" },
  {
    value: "FLE Standard Time",
    text: "(UTC+02:00) Helsinki, Kyiv, Riga, Sofia, Tallinn, Vilnius",
  },
  { value: "Israel Standard Time", text: "(UTC+02:00) Jerusalem" },
  { value: "Kaliningrad Standard Time", text: "(UTC+02:00) Kaliningrad" },
  { value: "Sudan Standard Time", text: "(UTC+02:00) Khartoum" },
  { value: "Libya Standard Time", text: "(UTC+02:00) Tripoli" },
  { value: "Arabic Standard Time", text: "(UTC+03:00) Baghdad" },
  { value: "Arab Standard Time", text: "(UTC+03:00) Kuwait, Riyadh" },
  { value: "E. Africa Standard Time", text: "(UTC+03:00) Nairobi" },
  { value: "Iran Standard Time", text: "(UTC+03:30) Tehran" },
  { value: "Arabian Standard Time", text: "(UTC+04:00) Abu Dhabi, Muscat" },
  { value: "Azerbaijan Standard Time", text: "(UTC+04:00) Baku" },
  { value: "Russia Time Zone 3", text: "(UTC+04:00) Volgograd" },
  { value: "Mauritius Standard Time", text: "(UTC+04:00) Port Louis" },
  { value: "Georgian Standard Time", text: "(UTC+04:00) Tbilisi" },
  { value: "Caucasus Standard Time", text: "(UTC+04:00) Yerevan" },
  { value: "Afghanistan Standard Time", text: "(UTC+04:30) Kabul" },
  { value: "West Asia Standard Time", text: "(UTC+05:00) Ashgabat, Tashkent" },
  { value: "Pakistan Standard Time", text: "(UTC+05:00) Islamabad, Karachi" },
  {
    value: "India Standard Time",
    text: "(UTC+05:30) Chennai, Kolkata, Mumbai, New Delhi",
  },
  { value: "Sri Lanka Standard Time", text: "(UTC+05:30) Sri Jayawardenepura" },
  { value: "Nepal Standard Time", text: "(UTC+05:45) Kathmandu" },
  {
    value: "Central Asia Standard Time",
    text: "(UTC+06:00) Almaty, Novosibirsk",
  },
  { value: "Bangladesh Standard Time", text: "(UTC+06:00) Dhaka" },
  { value: "Myanmar Standard Time", text: "(UTC+06:30) Yangon (Rangoon)" },
  {
    value: "SE Asia Standard Time",
    text: "(UTC+07:00) Bangkok, Hanoi, Jakarta",
  },
  { value: "N. Central Asia Standard Time", text: "(UTC+07:00) Novosibirsk" },
  {
    value: "China Standard Time",
    text: "(UTC+08:00) Beijing, Chongqing, Hong Kong, Urumqi",
  },
  { value: "North Asia Standard Time", text: "(UTC+08:00) Krasnoyarsk" },
  {
    value: "Singapore Standard Time",
    text: "(UTC+08:00) Kuala Lumpur, Singapore",
  },
  { value: "W. Australia Standard Time", text: "(UTC+08:00) Perth" },
  { value: "Taipei Standard Time", text: "(UTC+08:00) Taipei" },
  { value: "Ulaanbaatar Standard Time", text: "(UTC+08:00) Ulaanbaatar" },
  { value: "North Asia East Standard Time", text: "(UTC+08:00) Irkutsk" },
  { value: "Japan Standard Time", text: "(UTC+09:00) Osaka, Sapporo, Tokyo" },
  { value: "Korea Standard Time", text: "(UTC+09:00) Seoul" },
  { value: "Cen. Australia Standard Time", text: "(UTC+09:30) Adelaide" },
  { value: "AUS Central Standard Time", text: "(UTC+09:30) Darwin" },
  { value: "E. Australia Standard Time", text: "(UTC+10:00) Brisbane" },
  {
    value: "AUS Eastern Standard Time",
    text: "(UTC+10:00) Canberra, Melbourne, Sydney",
  },
  {
    value: "West Pacific Standard Time",
    text: "(UTC+10:00) Guam, Port Moresby",
  },
  { value: "Tasmania Standard Time", text: "(UTC+10:00) Hobart" },
  { value: "Yakutsk Standard Time", text: "(UTC+10:00) Yakutsk" },
  { value: "Vladivostok Standard Time", text: "(UTC+11:00) Vladivostok" },
  {
    value: "Central Pacific Standard Time",
    text: "(UTC+11:00) Solomon Is., New Caledonia",
  },
  {
    value: "New Zealand Standard Time",
    text: "(UTC+12:00) Auckland, Wellington",
  },
  { value: "UTC+12", text: "(UTC+12:00) Coordinated Universal Time+12" },
  { value: "Fiji Standard Time", text: "(UTC+12:00) Fiji" },
  { value: "Magadan Standard Time", text: "(UTC+12:00) Magadan" },
  { value: "Tonga Standard Time", text: "(UTC+13:00) Nuku'alofa" },
  { value: "Samoa Standard Time", text: "(UTC+13:00) Samoa" },
  { value: "Line Islands Standard Time", text: "(UTC+14:00) Kiritimati" },
];
const ianaToWindowsMap = Object.entries(windowsToIanaMap).reduce(
  (acc, [win, iana]) => {
    acc[iana] = win;
    return acc;
  },
  {}
);
const timeZoneOptions = [
  {
    value: "null",
    text: "Select timezone",
    disabled: true,
  },
  {
    value: "America/New_York",
    text: "EST",
  },
  {
    value: "America/Chicago",
    text: "CST",
  },
  {
    value: "America/Los_Angeles",
    text: "PST",
  },
  {
    value: "UTC",
    text: "UTC",
  },
];
const AppFields = [
  { id: 'anniversary', label: 'Anniversary' },
  { id: 'business_name', label: 'Business Name' },
  { id: 'birthday', label: 'DOB' },
  { id: 'email', label: 'Email' },
  { id: 'full_name', label: 'Full Name' },
  { id: 'first_name', label: 'First Name' },
  { id: 'last_name', label: 'Last Name' },
  { id: 'phone', label: 'Phone' },
]
export {
  COUNTRIES,
  STATES,
  FONT_FAMILY,
  FONT_FAMILY1,
  FONT_WEIGHT,
  FONT_WEIGHT_LABELS,
  FROALA_DEFAULT_CONTENT,
  FROALA_CONFIG2,
  FROALA_CONFIG,
  FROALA_CONFIG3,
  SECTIONPOPUP_SAMPLE,
  SECTION_SAMPLE,
  ROW_SAMPLE,
  COLUMN_SAMPLE,
  BUTTON_SAMPLE,
  DEFAULT_THEME2,
  LANDING_ORIGINAL,
  PAGE_ORIGINAL,
  WIDTH_OPTIONS,
  BLOCK_TYPES,
  HOVER_EFFECTS,
  GALLERY_TYPES,
  GALLERY_KINDS,
  REVIEW_LAYOUTS,
  YOUTUBE_LAYOUTS,
  PODCAST_LAYOUTS,
  INPUT_THEMES,
  BUTTON_THEMES,
  BOX_SHADOWS,
  BORDER_OPTIONS,
  BORDER_STYLES,
  TIMEDELAY_OPTIONS,
  SLIDER_INNER_ELEMENT_ANIMATION_OPTIONS,
  SLIDER_INNER_ELEMENT_ANIMATION_SPEED_OPTIONS,
  SLIDER_INNER_ELEMENT_ANIMATION_OPTIONS1,
  SLIDER_INNER_ELEMENT_ANIMATION_SPEED_OPTIONS1,
  SLIDER_MAIN_ANIMATION_OPTIONS,
  RADIUS_EDGES,
  BG_POSITIONS,
  TIME_OPTIONS,
  TIMEZONES,
  SHADOW_THEMES,
  ICON_THEMES,
  TIMER_THEMES,
  ELEMENT_CATEGORIES,
  ALL_ELEMENTS,
  FORM_INPUTS,
  STRIPE_INTERVAL,
  DEFAULT_CARD,
  CARD_ICONS,
  DEFAULT_CARD_ICON,
  CARD_FIELDS,
  DEFAULT_CARD_FIELDS,
  CARD_DESIGNS,
  CARD_COLORS,
  ANIMATION_OPTIONS,
  windowsToIanaMap,
  windowsTimezones,
  ianaToWindowsMap,
  timeZoneOptions,
  AppFields,
}
